const getFileBaseUrl = () => {
  const fileBaseUrl = process.env.REACT_APP_FILE_BASE_URL?.trim();
  if (fileBaseUrl) {
    return fileBaseUrl.replace(/\/+$/, "");
  }

  const apiUrl = process.env.REACT_APP_API_URL || "";
  return apiUrl.replace(/\/api\/v\d+\/?$/i, "").replace(/\/+$/, "");
};

export const resolveFileUrl = (path) => {
  if (!path || typeof path !== "string") return "";

  const trimmed = path.trim();
  if (
    trimmed.startsWith("http://") ||
    trimmed.startsWith("https://") ||
    trimmed.startsWith("blob:") ||
    trimmed.startsWith("data:")
  ) {
    return trimmed;
  }

  const serverBaseUrl = getFileBaseUrl();
  if (!serverBaseUrl) return trimmed;

  const normalizedPath = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return `${serverBaseUrl}${normalizedPath}`;
};
